export default function infiniteScroll() {
    const feed = document.querySelector('[data-post-feed]');
    const pagination = document.querySelector('[data-pagination]');
    const next = pagination?.querySelector('.older-posts');
    if (!feed || !next || !('IntersectionObserver' in window)) return;

    const status = pagination.querySelector('[data-load-status]');
    const retry = pagination.querySelector('[data-load-retry]');
    const seenPosts = new Set([...feed.querySelectorAll('[data-post-id]')].map(post => post.dataset.postId));
    const visitedPages = new Set([window.location.href]);
    let busy = false;
    let failed = false;
    let exhausted = false;

    const observer = new IntersectionObserver((entries) => {
        if (entries.some(entry => entry.isIntersecting) && !failed) load();
    }, {rootMargin: '150px'});

    async function load() {
        if (busy || exhausted) return;
        const url = next.href;
        busy = true;
        failed = false;
        retry.hidden = true;
        status.textContent = 'Loading more stories...';
        observer.unobserve(next);
        try {
            if (visitedPages.has(url)) throw new Error('Pagination returned an already loaded page');
            const response = await fetch(url);
            if (!response.ok) throw new Error(`Stories request failed (${response.status})`);
            const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
            const nextFeed = parsed.querySelector('[data-post-feed]');
            if (!nextFeed) throw new Error('The next page did not contain a story feed');
            const posts = [...nextFeed.querySelectorAll(':scope > [data-post-id]')];
            const nextPageLink = parsed.querySelector('[data-pagination] .older-posts');
            const following = nextPageLink ? new URL(nextPageLink.getAttribute('href'), url).href : null;
            if (following && (new URL(following).origin !== window.location.origin || following === url || visitedPages.has(following))) {
                throw new Error('Invalid next-page link');
            }
            const fresh = posts.filter(post => !seenPosts.has(post.dataset.postId));
            if (!fresh.length && following) throw new Error('Pagination returned no new stories');
            for (const post of fresh) {
                seenPosts.add(post.dataset.postId);
                feed.append(post);
            }
            visitedPages.add(url);
            status.textContent = fresh.length ? `${fresh.length} more stories loaded.` : 'All stories loaded.';
            if (following) {
                next.href = following;
                const counter = pagination.querySelector('.page-number');
                const nextCounter = parsed.querySelector('.page-number');
                if (counter && nextCounter) counter.textContent = nextCounter.textContent;
            } else {
                exhausted = true;
                next.hidden = true;
                const counter = pagination.querySelector('.page-number');
                if (counter) counter.hidden = true;
                observer.disconnect();
            }
        } catch (error) {
            failed = true;
            status.textContent = 'More stories could not be loaded. Try again or use the next-page link.';
            retry.hidden = false;
            console.error('Journal pagination failed:', error);
        } finally {
            busy = false;
            if (!exhausted && !failed) observer.observe(next);
        }
    }

    retry.addEventListener('click', load);
    observer.observe(next);
}
